import popup from '../modules/Popup';
const { __ } = wp.i18n;

const copy = () => {
  navigator.clipboard.writeText(event.target.dataset.url)
    .then(() => {
      popup.open({
        title: __('Copied!', 'canopia'),
        type: 'success',
        close: {
          text: __('Ok', 'canopia'),
        }
      });
    }, () => {
      popup.open({
        title: __('Could not copy text', 'canopia'),
        type: 'warning',
        close: {
          text: __('Close', 'canopia'),
        }
      });
    });
}

document.body.addEventListener('click', event => {
  if(event.target.classList.contains('btn-copy')) {
    event.preventDefault();
    copy();
  }
})
